// import "./App.css";
import {
  getFirestore,
  doc,
  collection,
  getDocs,
  getDoc,
  updateDoc,
  where,
  query,
} from "firebase/firestore";
import {
  useDocumentData,
  useDocumentDataOnce,
} from "react-firebase-hooks/firestore";
import { useAuthState } from "react-firebase-hooks/auth";
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// Import the functions you need from the SDKs you need

import { getAnalytics } from "firebase/analytics";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRedo } from "@fortawesome/free-solid-svg-icons";

import "bootstrap/dist/css/bootstrap.min.css";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Accordion from "react-bootstrap/Accordion";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Container from "react-bootstrap/Container";
import Offcanvas from "react-bootstrap/Offcanvas";
// import * as moment from "moment";
import { useCollection } from "react-firebase-hooks/firestore";
import { useState, useEffect } from "react";
import ListGroup from "react-bootstrap/ListGroup";
import ListGroupItem from "react-bootstrap/esm/ListGroupItem";

import { decodeMacAddress, decodeSerialNumber } from "./helpers";
import AccordionBody from "react-bootstrap/esm/AccordionBody";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBBzepSPN2wdZfvan5GgyeeIREAV6k5BaU",
  authDomain: "loftie-4f472.firebaseapp.com",
  databaseURL: "https://loftie-4f472.firebaseio.com",
  projectId: "loftie-4f472",
  storageBucket: "loftie-4f472.appspot.com",
  messagingSenderId: "302939981606",
  appId: "1:302939981606:web:7fcb10ed6fe46fa437a3e7",
  measurementId: "G-L8VGQXX28P",
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
// const analytics = getAnalytics(firebaseApp);

const auth = getAuth(firebaseApp);

//

function LoftieSearch() {
  const [user, userLoading, userError] = useAuthState(auth);
  const [loftieSearch, setLoftieSearch] = useState("");
  const [loftieId, setLoftieId] = useState("");
  // const [macAddressSearch, setMacAddressSearch] = useState("")
  const [serialNumber, setSerialNumber] = useState("");
  const [unformattedSN, setUnformattedSN] = useState("");
  const [unformattedMAC, setUnformattedMAC] = useState("");

  const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

  const convertSN = (unformattedSN) => {
    console.log("unformatted Sn", unformattedSN);
    let formatSN = "";
    if (unformattedSN.length > 0) {
      for (let i = 0; i < unformattedSN.length - 1; i++) {
        formatSN += "3" + unformattedSN[i];
      }
      let lastLetter = unformattedSN[unformattedSN.length - 1].toString();
      let numberValue = (alphabet.indexOf(lastLetter) + 1).toString();
      let lastFormat = formatSN.replace(lastLetter, numberValue);
      let addDash = lastFormat.replace(/(\w{2})/g, "$1-");
      let finishFormat = addDash + `4${numberValue}`;
      console.log("finished format", finishFormat);
      setSerialNumber(finishFormat);
    }
  };

  const convertMACtoID = (unformattedMAC) => {
    const addL = "l" + unformattedMAC;
    const lowerCase = addL.toLowerCase();
    setLoftieId(lowerCase);
  };

  const devicesRef = collection(getFirestore(firebaseApp), "devices");
  const [deviceDoc, loading, error] = useCollection(
    query(devicesRef, where("state.serialNumber", "==", serialNumber || "")),
    {
      snapshotListenOptions: { includeMetadataChanges: true },
    }
  );
  const [macAddress, setMacAddress] = useState("");

  useEffect(() => {
    if (deviceDoc?.docs[0]?.data()) {
      const id = deviceDoc?.docs[0]?.id;
      setLoftieId(id);
      // const deviceState = deviceDoc?.docs[0]?.data()?.state
      // setMacAddress(deviceState.MAC)
      // console.log("device state", deviceState)
      // console.log("mac address", macAddress)
    }
  }, [deviceDoc]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search); // id=123
    const id = params.get("id"); // 123
    if (id) {
      setLoftieId(id);
      setLoftieSearch(id);
    }
  }, []);

  useEffect(() => {
    if (loftieId) {
      window.history.pushState(null, null, `?id=${loftieId}`);
    }
  }, [loftieId]);

  const findLoftie = (loftieId) => {
    setLoftieId(loftieId);
  };

  const [deviceId, setDeviceId] = useState("");

  // console.log(macAddress)
  // console.log("device id", deviceId)
  // const [userEmail, setUserEmail] = useState("")

  return (
    <div>
      {user ? (
        <Container>
          <br />
          <form
            onSubmit={(e) => {
              e.preventDefault();
              findLoftie(loftieSearch);
            }}
          >
            <InputGroup>
              <Form.Control
                type="text"
                value={loftieSearch}
                onChange={(e) => setLoftieSearch(e.target.value)}
                placeholder="loftie id"
              />
              <Button variant="primary" type="submit">
                Search
              </Button>
            </InputGroup>
            <br></br>
          </form>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              convertSN(unformattedSN);
            }}
          >
            <InputGroup>
              <Form.Control
                type="text"
                value={unformattedSN}
                onChange={(e) => setUnformattedSN(e.target.value)}
                // onChange={(e)=> setMacAddressSearch(e.target.value)}
                placeholder="serial number"
              />
              <Button variant="primary" type="submit">
                Search
              </Button>
            </InputGroup>
          </form>
          <br></br>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              convertMACtoID(unformattedMAC);
            }}
          >
            <InputGroup>
              <Form.Control
                type="text"
                value={unformattedMAC}
                onChange={(e) => setUnformattedMAC(e.target.value)}
                placeholder="mac address"
              />
              <Button variant="primary" type="submit">
                Search
              </Button>
            </InputGroup>
          </form>
          <br></br>
          <div>{loftieId && <LoftieDetails loftieId={loftieId} />}</div>
        </Container>
      ) : (
        <>Auth Required</>
      )}
    </div>
  );
}

function LoftieDetails({ loftieId }) {
  const [
    loftieDevice,
    loftieDeviceLoading,
    loftieDeviceError,
    deviceSnapshot,
    loftieDeviceReload,
  ] = useDocumentData(doc(getFirestore(firebaseApp), "devices", loftieId));

  const [
    loftieDetails,
    loftieDetailsLoading,
    loftieDetailsError,
    detailsSnapshot,
    loftieDetailsReload,
  ] = useDocumentDataOnce(
    doc(getFirestore(firebaseApp), "device-details", loftieId)
  );

  const [
    loftieHistory,
    loftieHistoryLoading,
    loftieHistoryError,
    historySnapshot,
    loftieHistoryReload,
  ] = useDocumentDataOnce(
    doc(getFirestore(firebaseApp), "device-history", loftieId)
  );

  const [state, setState] = useState("");
  const [customerServMAC, setCustomerServMAC] = useState("");

  const [users, setUsers] = useState([]);
  const [gettingUsers, setGettingUsers] = useState(false);

  const [mqttHistory, setMqttHistory] = useState([]);

  const findUsers = async () => {
    if (users.length > 0) return;
    setGettingUsers(true);
    const usersRef = collection(getFirestore(firebaseApp), "users");
    const usersSnapshot = await getDocs(usersRef);
    const usersList = usersSnapshot.docs.map((doc) => doc.data());
    console.log(usersList);
    const foundUsers = [];
    for (let i = 0; i < usersList.length; i++) {
      const user = usersList[i];
      if (user.devices && user.devices.length > 0) {
        user.devices.forEach((device) => {
          if (device.id === loftieId) {
            foundUsers.push(user);
          }
        });
      }
    }
    setUsers(foundUsers);
    setGettingUsers(false);
  };

  useEffect(() => {
    if (loftieHistory) {
      console.log("loftieHistory", loftieHistory);
      const mHistory = loftieHistory["mqtt_history"];

      if (mHistory) {
        const history = mHistory
          .map((item) => {
            return {
              topic: item.topic,
              timestamp: item.timestamp,
              data: item.data,
            };
          })
          .sort((a, b) => b.timestamp.seconds - a.timestamp.seconds);
        setMqttHistory(history);
      }
    }
  }, [loftieHistory]);

  const clockPluggedInStatus = () => {
    if (loftieDevice?.state?.["Ver"]?.toLowerCase().includes("lamp")) {
      if (loftieDevice?.connection?.status === "connected") {
        return "True";
      } else {
        return "False";
      }
    } else {
      return JSON.stringify(loftieDevice?.state["pluggedIn"]);
    }
  };

  const lastPlaylistSent = () => {
    const playlistHistory = loftieDetails?.["playlist_history"];
    if (playlistHistory) {
      const lastPlaylist = playlistHistory[playlistHistory.length - 1];
      return lastPlaylist;
    } else {
      return "None";
    }
  };

  //for playlist show
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
  };
  const decodeAlarmBitValue = (daysOfWeek) => {
    console.log(daysOfWeek);
    if (daysOfWeek === 0) {
      return "One Time";
    }
    const bin = daysOfWeek.toString(2).padStart(7, "0");
    const daysArray = [];
    const daysMapping = {
      0: "Su",
      1: "Mo",
      2: "Tu",
      3: "We",
      4: "Th",
      5: "Fr",
      6: "Sa",
    };
    let days = "";
    for (let i = 0; i < bin.length; i++) {
      if (bin[bin.length - 1 - i] === "1") {
        days += daysMapping[i] + " ";
      }
    }
    console.log(days, days.trim);
    return days.trim();
  };

  const [showDeviceAlarms, setShowDeviceAlarms] = useState(false);

  const [alarmLogArray, setAlarmLogArray] = useState([]);
  const alarmLogs = () => {
    console.log(loftieDevice?.state?.alarmLogs);
    const allAlarmLogs = loftieDevice?.state?.alarmLogs;
    allAlarmLogs.map((log) => {
      if (log.start != "-") {
        const alarmLog = log?.start;
        setAlarmLogArray((prevArray) => [...prevArray, alarmLog]);
      }
    });
  };

  // console.log(alarmLogArray)

  const displayDeviceAlarms = () => {
    console.log("alarms", loftieDevice.state.alarms);
    const alarms = loftieDevice.state.alarms;
    const allAlarmLogs = loftieDevice?.state?.alarmLogs;
    let showLogs = false;
    const newLogCommands = ["dismiss", "snooze", "wakeup", "getup"];
    // if (allAlarmLogs) {
    //   showLogs = allAlarmLogs.some((log) => log.start !== "-");

    //   showLogs = !allAlarmLogs.some((log) =>
    //     Object.values(log).some((value) =>
    //       newLogCommands.some((word) => value.toLowerCase().includes(word))
    //     )
    //   );
    // }
    return (
      <Offcanvas show={showDeviceAlarms} onHide={handleClose}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Alarm Details</Offcanvas.Title>
        </Offcanvas.Header>
        {alarms.length === 0 ? (
          <Offcanvas.Body>No Alarms</Offcanvas.Body>
        ) : (
          <>
            <Offcanvas.Body>
              Alarms
              {alarms.map((alarm) => (
                <Accordion alwaysOpen>
                  <Accordion.Header onClick={(e) => e.stopPropagation()}>
                    <span style={{ color: "CornflowerBlue" }}>
                      {alarm.time} {alarm?.type ? alarm.type : "alarm"}
                    </span>
                  </Accordion.Header>
                  <AccordionBody>
                    <ListGroup>
                      <ListGroup.Item>
                        Type: {alarm?.type ? alarm.type : "alarm"}
                      </ListGroup.Item>
                      <ListGroup.Item>
                        Set: {alarm.isSet ? "On" : "Off"}
                      </ListGroup.Item>
                      <ListGroup.Item>
                        Days: {decodeAlarmBitValue(alarm.daysOfWeek)}
                      </ListGroup.Item>
                    </ListGroup>
                  </AccordionBody>
                </Accordion>
              ))}
            </Offcanvas.Body>
            <Offcanvas.Body>
              Alarm Logs
              <Accordion>
                <Accordion.Header onClick={(e) => e.stopPropagation()}>
                  <span style={{ color: "CornflowerBlue" }}>Logs</span>
                </Accordion.Header>
                <Accordion.Body>
                  {showLogs ? (
                    <ListGroup>
                      {allAlarmLogs.map((log, index) => {
                        if (log.start !== "-") {
                          const datePart = log.start.substring(0, 10);
                          const dayPart = log.start.substring(11, 14);
                          const timePart = log.start.substring(16, 24);
                          return (
                            <ListGroup>
                              <ListGroup.Item> Date: {datePart}</ListGroup.Item>
                              <ListGroup.Item> Day: {dayPart}</ListGroup.Item>
                              <ListGroup.Item> Time: {timePart}</ListGroup.Item>
                              <br />
                            </ListGroup>
                          );
                        }
                        return null;
                      })}
                    </ListGroup>
                  ) : (
                    <p>no recent logs</p>
                  )}
                </Accordion.Body>
              </Accordion>
            </Offcanvas.Body>
          </>
        )}
      </Offcanvas>
    );
  };

  const showPlaylist = (playlist) => {
    const playlists = playlist?.["playlists"];
    if (playlists) {
      const storyPlaylists = playlists[0];
      return show ? (
        <Offcanvas show={show} onHide={handleClose}>
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Stories in Playlist</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            {storyPlaylists?.tracks.map((item, i) => (
              <ListGroup variant="flush">
                <ListGroup.Item>
                  {i + 1}. {item.Name}
                </ListGroup.Item>
              </ListGroup>
            ))}
          </Offcanvas.Body>
        </Offcanvas>
      ) : null;
    }
  };

  const getAPMacAddress = () => {
    if (loftieDevice?.state?.["AP_MAC"]) {
    }
  };

  // const getClockPlaylist = (playlistId) => {
  //   const playlistHistory = loftieDetails?.['playlist_history']
  //   if (playlistHistory) {
  //     for (let i = 0; i < playlistHistory.length; i++) {
  //       if (playlistId === playlistHistory[i]['id']) {
  //         return playlistHistory[i]
  //       }
  //     }
  //   }
  // }

  const playlistInfo = loftieDevice?.state?.["playlistInfos"];

  const rssiColorValue = (rssi) =>
    rssi >= -70
      ? "seagreen"
      : rssi >= -80
      ? "gold"
      : rssi >= -100
      ? "orange"
      : rssi < -100
      ? "crimson"
      : "black";

  const restartDevice = async () => {
    const restart = window.confirm(
      "Are you sure you want to restart this device?"
    );
    if (!restart) return;

    const loftieConfigRef = doc(
      collection(getFirestore(firebaseApp), "device-configs"),
      loftieId
    );
    try {
      const docSnap = await getDoc(loftieConfigRef);
      if (docSnap.exists()) {
        const value = {
          restart: 1,
        };
        updateDoc(loftieConfigRef, { value: value });
        alert("Device restart command sent.");
      }
    } catch (error) {
      console.log(error);
    }

    // send restart command to device
  };
  const [activeKeys, setActiveKeys] = useState([]);
  const [expandAll, setExpandAll] = useState(false);

  useEffect(() => {
    if (expandAll) {
      setActiveKeys(
        mqttHistory.map((item) => item.timestamp.seconds + item.topic)
      );
    } else {
      setActiveKeys([]);
    }
  }, [expandAll, mqttHistory]);

  const toggleExpandAll = () => {
    setExpandAll(!expandAll);
  };

  const toggleItem = (key) => {
    if (activeKeys.includes(key)) {
      setActiveKeys(activeKeys.filter((activeKey) => activeKey !== key));
    } else {
      setActiveKeys([...activeKeys, key]);
    }
  };

  const getNativeDeviceId = () => {
    const macAddress = loftieDevice?.macAddress;
    if (macAddress) {
      // If MAC is encoded, decode it first, otherwise use as-is
      return "l" + macAddress.toLowerCase();
    }
    return null;
  };

  const nativeDeviceId =
    loftieId && loftieId.length > 13 ? getNativeDeviceId() : null;

  return (
    <div>
      <h5>{loftieId}</h5>
      &nbsp;&nbsp;
      {nativeDeviceId && (
        <div style={{ marginTop: "-10px", marginBottom: "10px" }}>
          <a href={`/loftie?id=${nativeDeviceId}`}>native device id</a>
        </div>
      )}
      {loftieDeviceLoading || loftieDetailsLoading || loftieHistoryLoading ? (
        <>Loading...</>
      ) : null}
      {loftieDevice && (
        <>
          <div>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Device Type</th>
                  <th>Firmware</th>
                  <th>Online Status</th>
                  <th>Online Status Updated</th>
                  <th> AP MAC Address</th>
                  <th>RSSI Value</th>
                  <th>Plugged In</th>
                  <th>SD Card Fail</th>
                  <th>Mac Address</th>
                  <th>Serial Number</th>
                  <th>Device Name</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {loftieDevice?.state?.["Ver"]
                      ?.toLowerCase()
                      .includes("lamp")
                      ? "Lamp"
                      : "Clock"}
                  </td>
                  <td>{loftieDevice?.state?.["Ver"]}</td>
                  <td
                    style={{
                      color:
                        loftieDevice?.connection?.status == "connected"
                          ? "seagreen"
                          : "crimson",
                    }}
                  >
                    {loftieDevice?.connection?.status || "offline"}
                  </td>
                  <td>
                    {new Date(
                      loftieDevice?.connection?.timestamp
                    )?.toLocaleDateString()}{" "}
                    {new Date(
                      loftieDevice?.connection?.timestamp
                    )?.toLocaleTimeString() || ""}
                  </td>
                  <td>{loftieDevice?.state?.["AP_MAC"]}</td>
                  <td
                    style={{
                      color: rssiColorValue(loftieDevice?.state?.["rssi"]),
                    }}
                  >
                    {loftieDevice?.state?.["rssi"] || "None posted"}
                  </td>
                  <td>{clockPluggedInStatus()}</td>
                  <td
                    style={{
                      color:
                        loftieDevice?.state?.["SDCardFail"] === true
                          ? "crimson"
                          : "inherit",
                    }}
                  >
                    {String(loftieDevice?.state?.["SDCardFail"])}
                  </td>
                  <td>{decodeMacAddress(loftieDevice?.state["MAC"])}</td>
                  <td>
                    {decodeSerialNumber(loftieDevice?.state?.["serialNumber"])}
                  </td>
                  <td>{loftieDetails?.["name"]}</td>
                </tr>
              </tbody>
            </Table>
          </div>
          <Button
            style={{ marginRight: "10px" }}
            onClick={() => setShowDeviceAlarms(!showDeviceAlarms)}
          >
            Alarm Details
            {displayDeviceAlarms()}
          </Button>
          <Button variant="primary" onClick={() => restartDevice()}>
            Restart Device
          </Button>
          <br></br>
          <br></br>
          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                Users connected to this device (tap to search)
              </Accordion.Header>
              <Accordion.Body onEntered={() => findUsers()}>
                <div>
                  {gettingUsers ? (
                    <>Loading (this will take 20-30 seconds)...</>
                  ) : users.length === 0 ? (
                    <>No users found</>
                  ) : null}
                  {users.map((user) => (
                    <>
                      <a href={`/user?email=${user.email}`} target="_blank">
                        <div>{user.email}</div>
                      </a>
                    </>
                  ))}
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
          <br></br>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Clock Playlist</th>
                <th>Last Playlist sent</th>
                <th>Pending playlist</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <ListGroup>
                    <ListGroup.Item>id: {playlistInfo?.["id"]}</ListGroup.Item>
                    <ListGroup.Item>
                      playlist state: {playlistInfo?.["state"]}
                    </ListGroup.Item>
                    <ListGroup.Item>
                      Default: {playlistInfo?.["isDefault"] ? "True" : "False"}
                    </ListGroup.Item>
                    <ListGroup.Item
                      action
                      onClick={() => setShow(!show)}
                      variant="info"
                    >
                      Stories
                      {/* {showPlaylist(getClockPlaylist(playlistInfo?.['id']))} */}
                    </ListGroup.Item>
                  </ListGroup>
                </td>
                <td>
                  {lastPlaylistSent() ? (
                    <ListGroup>
                      <ListGroup.Item>
                        {" "}
                        id: {lastPlaylistSent()["id"]}
                      </ListGroup.Item>
                      <ListGroupItem
                        action
                        onClick={() => setShow(!show)}
                        variant="info"
                      >
                        Stories
                        {showPlaylist(lastPlaylistSent())}
                      </ListGroupItem>
                    </ListGroup>
                  ) : (
                    "No playlist history"
                  )}
                </td>
                <td>
                  {loftieDetails?.["pending_playlist"] ? (
                    <div>
                      <ListGroup>
                        <ListGroup.Item>
                          id: {loftieDetails?.["pending_playlist"]["id"]}
                        </ListGroup.Item>
                        <ListGroup.Item
                          action
                          onClick={() => setShow(!show)}
                          variant="info"
                        >
                          Stories
                          {showPlaylist(
                            loftieDetails?.["pending_playlist"]["playlists"]
                          )}
                        </ListGroup.Item>
                      </ListGroup>
                    </div>
                  ) : (
                    "None"
                  )}
                </td>
              </tr>
            </tbody>
          </Table>
          <Accordion alwaysOpen>
            <Accordion.Item eventKey="0">
              <Accordion.Header>Current State JSON</Accordion.Header>
              <Accordion.Body>
                <div>
                  <pre>{JSON.stringify(loftieDevice, null, 2)}</pre>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
          <br></br>
          <h6>
            MQTT History (beta - report any issues){" "}
            <FontAwesomeIcon
              onClick={() => loftieDetailsReload()}
              style={{ cursor: "pointer" }}
              icon={faRedo}
            />
          </h6>

          <Button variant="outline-primary" onClick={toggleExpandAll}>
            {expandAll ? "Collapse All" : "Expand All"}
          </Button>
          <br></br>
          <br></br>

          <Accordion flush alwaysOpen activeKey={activeKeys}>
            {mqttHistory.map((item, i) => {
              const key = item.timestamp.seconds + item.topic;
              return (
                <Accordion.Item eventKey={key} key={key}>
                  <Accordion.Header onClick={() => toggleItem(key)}>
                    <strong class="mr-3">{item.topic}</strong>&nbsp;
                    {new Date(
                      item.timestamp.seconds * 1000
                    ).toLocaleDateString()}{" "}
                    {new Date(
                      item.timestamp.seconds * 1000
                    ).toLocaleTimeString()}{" "}
                    {i < mqttHistory.length - 1 && item.topic == "state" && (
                      <IndexMQTTStatus index={i} allItems={mqttHistory} />
                    )}
                  </Accordion.Header>
                  <Accordion.Body>
                    {/* <div> */}
                    <div>
                      <pre>{JSON.stringify(item.data, null, 2)}</pre>
                    </div>
                    {/* </div> */}
                  </Accordion.Body>
                </Accordion.Item>
              );
            })}
          </Accordion>
        </>
      )}
      {/* {loftieDevice && JSON.stringify(loftieDetails)} */}
    </div>
  );
}
const IndexMQTTStatus = ({ index, allItems }) => {
  const item = allItems[index];
  const connectionStatus = item.data?.connection?.status;
  const APMacAddress = item.data?.state?.["AP_MAC"];
  const sdCardFail = item.data?.state?.["SDCardFail"];

  const mostRecentState = allItems
    .slice(index + 1)
    .find((elem) => elem.topic == "state");

  const mostRecentStateConnectionStatus =
    mostRecentState?.data?.connection?.status;

  const mostRecentAPMacAddress = mostRecentState?.data?.state?.["AP_MAC"];
  const mostRecentSdCardFail = mostRecentState?.data?.state?.["SDCardFail"];
  const mostRecentVersion = mostRecentState?.data?.state?.["Ver"];
  const previousVersion = item.data?.state?.["Ver"];

  const connectionChanged =
    connectionStatus != mostRecentStateConnectionStatus ? connectionStatus : "";
  const APMacAddressChanged =
    APMacAddress != mostRecentAPMacAddress ? APMacAddress : " ";
  const sdCardFailChanged =
    sdCardFail !== mostRecentSdCardFail ? sdCardFail : "";
  const versionChanged =
    previousVersion != mostRecentVersion ? previousVersion : "";
  const rssi = mostRecentState?.data?.state?.["rssi"];

  if (
    connectionChanged ||
    APMacAddress ||
    sdCardFailChanged !== "" ||
    versionChanged
  ) {
    return (
      <>
        <span
          style={{
            color: connectionStatus == "connected" ? "seagreen" : "crimson",
          }}
        >
          {" "}
          &nbsp;&nbsp;
          {connectionChanged}
        </span>{" "}
        &nbsp;&nbsp;
        <span style={{ color: "cadetblue" }}>
          {APMacAddressChanged == " " ? " " : "AP MAC: "} {APMacAddressChanged}
          &nbsp;&nbsp;
          {APMacAddressChanged == " " ? " " : ` rssi: ${rssi} `}
        </span>
        &nbsp;&nbsp;
        {sdCardFailChanged !== "" && (
          <span>
            SD Card Fail changed to:{" "}
            <span style={{ color: "blue" }}>{String(sdCardFail)}</span>
          </span>
        )}
        &nbsp;&nbsp;
        {versionChanged && (
          <span>
            Version changed from:{" "}
            <span style={{ color: "blue" }}>{previousVersion}</span> to{" "}
            <span style={{ color: "blue" }}>{mostRecentVersion}</span>
          </span>
        )}
      </>
    );
  } else {
    return null;
  }
};

export default LoftieSearch;
